import { LabelWithControl } from "components/common/LabelControl";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import clsx from "clsx";
import { IndividualHeader } from "./IndividualHeader";
import { Fragment } from "react";

export const POHeader = ({
  noOfOrders,
  comments,
  setComments,
  orderDate,
  setOrderDate,
  deliveryDate,
  setDeliveryDate,
  totalCases,
  totalPallets,
  totalBases,
  totalWagons,
}) => {
  const POList = [];
  for (let index = 1; index <= noOfOrders; index++) {
    POList.push(`PO ${index}`);
  }

  return (
    <div
      className={clsx("poHeaderStyling", { poHeaderContainer: noOfOrders > 1 })}
    >
      <Grid sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Box
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
            },
          }}
        >
          {/* Labels Row */}
          <Grid container spacing={1} sx={{ "& > *": { flex: 1 } }}>
            <Grid item xs={12} sm={6} md={3}>
              <LabelWithControl label="PO Identifier" />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Order Date" />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LabelWithControl label="Delivery Date" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Cases" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Pallets" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Bases" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Total Wagons" />
            </Grid>
            <Grid item xs={12} sm={6} md={1}>
              <LabelWithControl label="Comments" />
            </Grid>
          </Grid>
        </Box>

        {/* Data Rows */}
        {POList.map((item, index) => (
          <Fragment key={index}>
            <IndividualHeader
              poIdentifier={item}
              index={index}
              comments={comments}
              setComments={setComments}
              orderDate={orderDate}
              setOrderDate={setOrderDate}
              deliveryDate={deliveryDate}
              setDeliveryDate={setDeliveryDate}
              totalCases={totalCases}
              totalPallets={totalPallets}
              totalBases={totalBases}
              totalWagons={totalWagons}
            />
          </Fragment>
        ))}
      </Grid>
    </div>
  );
};
